<div class="sidebar-container d-flex flex-column justify-content-between p-4">
    <div class="d-flex justify-content-start align-items-center" (click)="dialogRef.close()">
        <mat-icon fontIcon="arrow_back" class="back-icon"></mat-icon>
        <span>Back</span>
    </div>

    <h2 class="mt-4">How would you like to send money</h2>
    <p class="subtitle mb-4">Select an option to proceed</p>

    <div class="transfer-option intra-wallet" (click)="selectPeerToPeer(transferType.INTRA_WALLET)">
        <div class="icon">
            <img src="assets/intra-wallet-icon.svg" alt="Intra-wallet Transfer Icon" />
        </div>
        <div>
            <h3>Intra-wallet Transfer</h3>
            <p>Transfer money within your wallet</p>
        </div>
    </div>

    <div class="transfer-option peer-to-peer" (click)="selectPeerToPeer(transferType.PEER_TO_PEER)">
        <div class="icon">
            <img src="assets/p2p.svg" alt="Peer to Peer Icon" />
        </div>
        <div>
            <h3>Peer to Peer</h3>
            <p>Send money to an account</p>
        </div>
    </div>

    <div class="notice w-100 d-flex justify-content-center align-items-center">
        <span class="me-2">*</span>
        <p>Sending/transferring money from <strong>SDG to USD</strong> is <span>not permitted</span></p>
    </div>
</div>
